import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  Renderer2,
  Signal,
  ViewChild,
} from "@angular/core";
import { ActivatedRoute, NavigationExtras, Router } from "@angular/router";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";
import * as FileSaver from "file-saver";
import {
  Table,
  TableFilterEvent,
  TableLazyLoadEvent,
  TableModule,
} from "primeng/table";
import { debounceTime, distinctUntilChanged, Subject } from "rxjs";
import { OrderListingPaginatedService } from "../../../../core/services/order-listing-paginated.service";
import saveAs from "file-saver";
import { CommonModule, DatePipe } from "@angular/common";
import { DashbaordPocAdditionalFilters } from "../../../../core/models/common/dashboardPocAdditionalFilters.dto";
import { DateFilter } from "../../../../core/models/common/date-filter-request.dto";
import { GenericFilterRequestDto } from "../../../../core/models/generic-filter-request.dto";
import { GenericSortRequestDto } from "../../../../core/models/generic-sort-request.dto";
import { GetProjectInvoiceProposalsList } from "../../../../core/models/orders/getInvoicebySalesOrderIdResponseDto.dto";
import { ProjectInvoiceReportSalesInvoiceList } from "../../../../core/models/orders/getProjectInvoiceReportSalesResponseDto";
import { GetSaleOrdersDto } from "../../../../core/models/orders/getSaleOrdersDto";
import { SharedService } from "../../../../core/services/shared.service";
import { UserRole } from "../../../../shared/enums/userRoles.enum";
import { UserManagementService } from "../../../../core/services/user-management.service";
import { ModalStackerComponent } from "../../../../shared/components/modal-stacker/modal-stacker.component";
import { OrderSummaryComponent } from "../order-summary/order-summary.component";
import { InvoicePdfDialogueComponent } from "../invoice-pdf-dialogue/invoice-pdf-dialogue.component";
import { InvoicePreviewListDailogComponent } from "../invoice-preview-list-dailog/invoice-preview-list-dailog.component";
import { DialogModule } from "primeng/dialog";
import { FormsModule } from "@angular/forms";
import { DatePickerModule } from "primeng/datepicker";
import { BooleanToStringPipe } from "../../../../shared/pipes/booleanToString/booleanToString.pipe";
import { HidedynamicsdatePipe } from "../../../../shared/pipes/hidedate/hidedynamicsdate.pipe";
import { JniToastrService } from "../../../../core/services/jni-toastr.service";
import { SidebarService } from "../../../../core/services/sidebar.service";
import { DateFilterComponent } from "../../../../shared/components/date-filter/date-filter.component";
import { RadioButtonModule } from "primeng/radiobutton";
import { SelectModule } from "primeng/select";
import { CardModule } from "primeng/card";
import { ButtonModule } from "primeng/button";
import { FilterMetadata } from "primeng/api";
import { SpinnerComponent } from "../../../../shared/components/spinner/spinner.component";
import { ClientDetailsComponent } from "../../../clients/components/client-details/client-details.component";
import { PdfViewerPageComponent } from "../../../../shared/components/pdf-viewer-page/pdf-viewer-page.component";

@UntilDestroy()
@Component({
  selector: "jni-order-listing-paginated",
  templateUrl: "./order-listing-paginated.component.html",
  styleUrls: ["./order-listing-paginated.component.scss"],
  imports: [
    TableModule,
    CommonModule,
    ModalStackerComponent,
    OrderSummaryComponent,
    InvoicePdfDialogueComponent,
    InvoicePreviewListDailogComponent,
    DialogModule,
    FormsModule,
    SelectModule,
    DatePickerModule,
    BooleanToStringPipe,
    HidedynamicsdatePipe,
    DateFilterComponent,
    RadioButtonModule,
    CardModule,
    ButtonModule,
    SpinnerComponent,
    ClientDetailsComponent,
  ],
})
export class OrderListingPaginatedComponent implements OnInit {
  saleordersListing: GetSaleOrdersDto[] = [];
  filterSaleordersListing: GetSaleOrdersDto[] = [];
  selectedorderListing: GetSaleOrdersDto[] = [];
  listAfterGridFilter: GetSaleOrdersDto[] = [];
  //ordersfilterList: any[] = [];
  showSmallLoader = false;
  checkboxStatus = 0;
  currentPagination = 50;
  totalRecords = 0;
  defaultTake = 250;
  @ViewChild("dt") table!: Table;
  lazyLoadEvent!: TableLazyLoadEvent;
  filterDebounceTime = 1000;
  filterTextChanged: Subject<Event | DateFilter | GetSaleOrdersDto[] | null> =
    new Subject<Event | DateFilter | GetSaleOrdersDto[] | null>();
  orderDisplayModal = false;
  clientDisplayModal = false;
  saleOrderId = "";
  customerId = "";
  selectedRadioButton = "All";
  invoicePdfDialogue = false;
  orderCreatedDateFilterValue = "";
  selectedMatchMode = "between";
  startDate = "";
  endDate = "";
  showFilterDialog = false;
  descriptionCharacterCond = false;
  custPoCharacterCount = false;
  matchModeOptions = [
    { label: "Between", value: "between" },
    { label: "Date is", value: "dateIs" },
    { label: "Date before", value: "dateBefore" },
    { label: "Date after", value: "dateAfter" },
  ];
  isError = false;
  errorLabel = "";
  invoiceList: ProjectInvoiceReportSalesInvoiceList[] = [];
  excelRequest: DashbaordPocAdditionalFilters =
    {} as DashbaordPocAdditionalFilters;

  @Input() customerAccountNumber = "";
  @Output() openOrderListingModal = new EventEmitter<void>();

  @Input() isAdditionalFilters = false;
  @Input() orderType = "";
  @Input() isFromSupportAllocation = false;

  searchPlaceholder = "Search";
  inHandDateFilter = {} as DateFilter;
  filterMode = "server";
  inHandFieldName = "inHandsDateD365";
  invoiceReviewSummaryDisplayModal = false;
  IrSalesOrderId = "";
  IrprojId = "";
  popupSmallLoader = false;
  projectInvoicesProposalList = [] as GetProjectInvoiceProposalsList[];
  displayProjectInvoiceProposal = false;
  userRole = 0;
  enumUserRole = UserRole;
  menuSelected!: Signal<string>;
  constructor(
    private _router: Router,
    private _toastr: JniToastrService,
    private _orderListingPaginatedService: OrderListingPaginatedService,
    private renderer: Renderer2,
    private _activatedRoute: ActivatedRoute,
    public _sharedService: SharedService,
    public datepipe: DatePipe,
    public _loginService: UserManagementService,
    private _sidebarService: SidebarService
  ) {
    this.menuSelected = this._sidebarService.menu$;
    this.closeModalOnSaleOrder();
  }

  ngOnInit(): void {
    this.getUserProfile();
    this.closeModalOnSaleOrder();

    this._activatedRoute.params.subscribe(params => {
      this.isAdditionalFilters =
        params["isAdditionalFilters"] == "1" ? true : this.isAdditionalFilters;
      if (!this.isAdditionalFilters) {
        this._sharedService.clearDashbaordPocAdditionalFiltersObject();
      }
    });

    this._sharedService.searchTextValueBehaviorSubject.subscribe(x => {
      // this.searchedText = x;
      if (x) {
        this.searchPlaceholder = `Results for "${x}"`;
      }
    });
  }

  closeModalOnSaleOrder() {
    if (this.menuSelected() === "orders") {
      this.orderDisplayModal = false;
      this.clientDisplayModal = false;
    }
  }

  convertDateFormat(date: string) {
    return this.datepipe.transform(date, "yyyy-MM-dd") ?? "";
  }

  getAllSaleOrder(event: TableLazyLoadEvent) {
    this.clearAdditionalFilters();
    this.lazyLoadEvent = event;
    this.showSmallLoader = true;
    const eventFilterArray = Object.keys(event.filters ?? {});
    const filter: GenericFilterRequestDto[] = eventFilterArray.map(x => {
      const tableFilter = event?.filters?.[x] as FilterMetadata;
      const data = {
        columnName: x ?? "",
        matchMode: tableFilter.matchMode ?? "",
        tableName: "",
        value: tableFilter.value ?? "",
      } as GenericFilterRequestDto;

      return data;
    });

    const sortArray: GenericSortRequestDto[] =
      event.multiSortMeta?.map(x => {
        return {
          ...x,
        } as GenericSortRequestDto;
      }) ?? [];

    let isInventorySales = this.orderType == "inventory-sales";
    filter.forEach(x => {
      if (x.columnName == "salesOrderIdD365") {
        x.columnName = "SalesOrderIdD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "salesOrderStatusD365") {
        x.columnName = "SalesOrderStatusD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "jobNameD365") {
        x.columnName = "JobNameD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "organizationNameD365") {
        x.columnName = "NameAliasD365";
        x.tableName = "Client";
      }
      if (x.columnName == "buyerD365") {
        x.columnName = "BuyerD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "foreignCurrencyD365") {
        x.columnName = "ForeignCurrencyD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "customerPONumberD365") {
        x.columnName = "CustomerPONumberD365";
        x.tableName = "SalesOrderHeader";
      }
      if (x.columnName == "brandingConsultant") {
        x.columnName = "FirstName,LastName";
        x.tableName = "Employee";
      }
      if (x.columnName == "accountsCoordinator") {
        x.columnName = "FirstName,LastName";
        x.tableName = "accountsCoordinator";
      }
      if (
        x.columnName == "jniSalesInventoryD365" &&
        x.value.toLowerCase().startsWith("y")
      ) {
        isInventorySales = true;
      }

      if (x.columnName == "orderSubTotal") {
        x.columnName = "Volume";
        x.tableName = "SalesOrderHeader";
      }

      const createdDateValue =
        this.convertDateFormat(this.startDate ?? "") +
        "|" +
        this.convertDateFormat(this.endDate ?? "");

      if (x.columnName == "createdDate") {
        x.columnName = "CreatedDate";
        x.tableName = "SalesOrderHeader";
        x.value = createdDateValue;
        x.matchMode = this.selectedMatchMode;
      }

      const inHandDate =
        this.convertDateFormat(this.inHandDateFilter.startDate ?? "") +
        "|" +
        this.convertDateFormat(this.inHandDateFilter.endDate ?? "");
      if (x.columnName == "inHandsDateD365") {
        x.columnName = "InHandsDateD365";
        x.tableName = "SalesOrderHeader";
        x.value = inHandDate;
        x.matchMode = this.inHandDateFilter.selectedMatchMode;
      }
    });

    const obj = this._sharedService.getDashbaordPocAdditionalFiltersObject();
    const objSimpleOrderSearch =
      this._sharedService.getSimpleOrderSearchResponseObject();
    const searchedText = this._sharedService.getOrderSearchValue();

    // Helper function to validate and format dates
    const getValidDate = (
      dateValue: string | undefined
    ): string | undefined => {
      if (!dateValue || dateValue.trim() === "") {
        return undefined;
      }
      return dateValue;
    };

    const request: DashbaordPocAdditionalFilters = {
      skip: event.first ?? 0,
      take: event.rows ?? this.defaultTake,
      filters: filter,
      sort: sortArray,
      additionalFilters: obj.additionalFilters,
      bacNumber: obj.bacNumber,
      brandingConsultant: obj.brandingConsultant,
      status: obj.additionalFilters
        ? (obj.status ?? this.selectedRadioButton)
        : this.selectedRadioButton,
      fromDate: getValidDate(obj.fromDate),
      toDate: getValidDate(obj.toDate),
      customerAccountNumber: obj.customerAccountNumber,
      isSimpleOrderSearch:
        searchedText?.length || obj.dashboardSalesOrderId?.length
          ? true
          : false,
      simpleSearchSaleOrderIds: objSimpleOrderSearch?.length
        ? objSimpleOrderSearch
        : obj.dashboardSalesOrderId,
      orderCreatedDateFilterCriteria: this.selectedMatchMode,
      applyNonAdminRules: obj.applyNonAdminRules,
      brandingConsultantNumber: obj.brandingConsultantNumber,
      isInventorySales: isInventorySales,
    } as DashbaordPocAdditionalFilters;

    if (this.customerAccountNumber) {
      request.customerAccountNumber = this.customerAccountNumber;
      request.additionalFilters = true;
    }

    this.excelRequest = request;
    // this.clearAndSetSimpleOrderSearchResponseObj();
    // this._sharedService.setOrderSearchValue('');
    this._orderListingPaginatedService
      .getAllSaleOrders(request)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.showSmallLoader = false;
          this.totalRecords = res.totalRecords ?? 0;
          this.saleordersListing = res.data;
          this.filterSaleordersListing = this.saleordersListing;
        },
        error: res => {
          this.showSmallLoader = false;
          this._toastr.error("Error", res.message || "Data not found");
        },
      });
  }

  clearAndSetSimpleOrderSearchResponseObj() {
    const orderSearch: string[] = [];
    this._sharedService.setSimpleOrderSearchResponseObject(orderSearch);
  }

  clearAdditionalFilters() {
    if (this.isAdditionalFilters !== true) {
      this._sharedService.clearDashbaordPocAdditionalFiltersObject();
    }
  }

  onOrdersRedirection() {
    const extras: NavigationExtras = {
      state: { orderType: this.orderType },
      queryParamsHandling: "preserve",
    };
    this._router.navigate(["orders/order-header"], extras);
  }

  exportExcel() {
    this.showSmallLoader = true;
    // if (this.selectedorderListing.length > 0) {
    //   this.exportExcelForFilterData(this.selectedorderListing);
    //   this.showSmallLoader = false;
    // } else {
    //   this.exportExcelAll();
    // }

    this.exportExcelForFilterData(this.filterSaleordersListing);
  }

  // onDateFilter(event: any) {
  //   if (event.target.value) {
  //     const filterList = this.saleordersListing.filter((x) =>
  //       x.inHandsDateD365?.includes(event.target.value)
  //     );
  //     this.filterSaleordersListing = filterList;
  //   } else {
  //     this.filterSaleordersListing = this.saleordersListing;
  //   }
  // }

  exportExcelForFilterData(filterclientlist: GetSaleOrdersDto[]) {
    const object = filterclientlist.map(datum => {
      return {
        ["Order #"]: datum.salesOrderIdD365,
        ["Pct"]: datum.orderPercentCompleteD365,
        ["Status"]: datum.salesOrderStatusD365,
        ["Paid Status"]: datum.prepayD365,
        ["Client Name"]: datum.customerName,
        ["Warehouse"]:
          datum?.jniSalesInventoryD365 === true
            ? (datum?.inventLocationIdD365 ?? "")
            : "",
        ["Owner"]:
          datum?.jniSalesInventoryD365 === true ? (datum?.ownerD365 ?? "") : "",
        ["Inventory Sales"]:
          datum?.jniSalesInventoryD365 === true ? "Yes" : "No",
        ["Job Name"]: datum.jobNameD365,
        ["Buyer"]: datum.buyerD365,
        ["In hands"]: new Date(datum.inHandsDateD365 ?? ""),
        ["Created"]: new Date(datum.createdDate),
        ["Subtotal"]: datum.orderSubTotal,
        ["PrePay"]: datum.clientDepositD365,
        ["Commission"]: datum.commissionD365,
        ["Gp%"]: datum.grossProfitPercentageD365 ?? 0,
        ["Currency"]: datum.foreignCurrencyD365,
        ["Cust PO"]: datum.customerPONumberD365,
        ["BC"]: datum.brandingConsultant,
        ["Prime Support"]: datum.accountsCoordinatorNameD365,
      };
    });

    import("xlsx").then(xlsx => {
      const worksheet = xlsx.utils.json_to_sheet(object);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ["data"] };
      const excelBuffer: ArrayBuffer = xlsx.write(workbook, {
        bookType: "xlsx",
        type: "array",
      });
      this.saveAsExcelFile(excelBuffer, "OrderList");
      this.showSmallLoader = false;
    });
  }

  saveAsExcelFile(buffer: ArrayBuffer, fileName: string): void {
    const EXCEL_TYPE =
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
    const EXCEL_EXTENSION = ".xlsx";
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE,
    });
    FileSaver.saveAs(
      data,
      fileName + "_export_" + new Date().getTime() + EXCEL_EXTENSION
    );
  }

  exportExcelAll() {
    this.showSmallLoader = true;

    this._orderListingPaginatedService
      .getSaleOrderInformationPaginatedExcel(this.excelRequest)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: (res: Blob) => {
          this.showSmallLoader = false;
          this.downloadFile(res);
        },
        error: () => {
          this.showSmallLoader = false;
        },
      });
  }

  downloadFile(data: Blob) {
    const file = new Blob([data], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    saveAs(file, `OrderList_export_${new Date().getTime()}.xlsx`);
  }

  redirectToSummary(saleOrderId: string) {
    if (saleOrderId) {
      this.saleOrderId = saleOrderId;
      this.orderDisplayModal = true;
    }
    // this._router.navigate(['orders/order-summary/' + saleOrderId]);
  }

  redirectToClientSummary(customerId: string) {
    if (customerId) {
      this.customerId = customerId;
      this.clientDisplayModal = true;
    }
    // this._router.navigate(['orders/order-summary/' + saleOrderId]);
  }

  closeModalForSaleOrder() {
    this.orderDisplayModal = false;
  }

  closeClientModal() {
    this.clientDisplayModal = false;
  }

  getInfinity(percentage: number) {
    if (Number.isFinite(percentage)) {
      return true;
    } else {
      return false;
    }
  }

  onFilter(event: TableFilterEvent, dt: Table) {
    this.currentPagination = dt._rows ?? 0;
    if (event.filters && event.filteredValue.length !== 0) {
      this.listAfterGridFilter = event.filteredValue;
    } else {
      this.listAfterGridFilter = [];
    }
  }

  lastPageStatus = true;
  setMyPagination(dt: Table) {
    this.currentPagination = dt._rows ?? 0;
    const pageDiff = dt._totalRecords - (dt._first ?? 0);
    if (pageDiff <= (dt._rows ?? 0)) {
      this.lastPageStatus = false;
    } else this.lastPageStatus = true;
  }

  onFilterInput(
    event: Event | DateFilter | GetSaleOrdersDto[] | null,
    value = ""
  ) {
    if (value === "clear") {
      this.clearFilter();
    }
    if (
      this.selectedMatchMode === "between" &&
      this.startDate &&
      this.endDate &&
      this.startDate > this.endDate
    ) {
      this.isError = true;
      this._toastr.error("Error", "Start date must be less than end date");
      return;
    }

    this.showFilterDialog = false;

    if (event && "startDate" in event) {
      this.inHandDateFilter = event;
    }
    if (this.filterTextChanged.observers.length === 0) {
      this.filterTextChanged
        .pipe(debounceTime(this.filterDebounceTime), distinctUntilChanged())
        .subscribe(() => {
          this.getAllSaleOrder(this.lazyLoadEvent);
        });
    }
    this.filterTextChanged.next(event);
  }

  getOrderOnChange(value: string) {
    // const target = value.originalEvent.target as HTMLInputElement;
    // if (target.id == "Openorder") {
    //   this.selectedRadioButton = "Open order";
    // } else {
    //   this.selectedRadioButton = target.id;
    // }
    this.filterTextChanged.observers.length = 0;
    this.selectedRadioButton = value;
    this.onFilterInput(null);
  }

  onStatusClick(salesOrderId: string) {
    if (salesOrderId) {
      this.showSmallLoader = true;
      this._orderListingPaginatedService
        .getProjectInvoiceReportSales({
          SalesOrderId: salesOrderId,
        })
        .pipe(untilDestroyed(this))
        .subscribe({
          next: res => {
            if (res?.status?.toLowerCase() == "success") {
              if (res.data) {
                if (res.data.InvoiceCount == 1) {
                  this.showSmallLoader = true;
                  this._orderListingPaginatedService
                    .getProjectInvoiceReport({
                      InvoiceDate: res.data.InvoiceList[0]?.InvoiceDate ?? "",
                      ProjectInvoiceId:
                        res.data.InvoiceList[0]?.ProjectInvoiceId,
                    })
                    .pipe(untilDestroyed(this))
                    .subscribe({
                      next: res => {
                        this.showSmallLoader = false;
                        if (res.data?.reportBase64String) {
                          PdfViewerPageComponent.openInNewTab(
                            res.data.reportBase64String,
                            `Nadel-SO#${salesOrderId}`
                          );

                          // const blob = this.b64toBlob(
                          //   res.data.reportBase64String,
                          //   "application/pdf"
                          // );
                          // const blobUrl = URL.createObjectURL(blob);
                          // window.open(blobUrl);
                        } else {
                          this._toastr.error(
                            "Error",
                            res.message || "Failed To Fetch Invoice PDF"
                          );
                        }
                      },
                      error: () => {
                        this.showSmallLoader = false;
                        this._toastr.error(
                          "Error",
                          "Failed To Fetch Invoice PDF"
                        );
                      },
                    });
                } else if (res.data.InvoiceCount > 1) {
                  this.showSmallLoader = false;
                  this.invoiceList = res.data.InvoiceList;
                  this.invoicePdfDialogue = true;
                } else {
                  this.showSmallLoader = false;
                  this._toastr.error(
                    "Error",
                    res.message || "Failed To Fetch Invoice PDF"
                  );
                }
              } else {
                this.showSmallLoader = false;
                this._toastr.error(
                  "Error",
                  res.message || "Failed To Fetch Invoice PDF"
                );
              }
            } else {
              this.showSmallLoader = false;
              this._toastr.error(
                "Error",
                res.message || "Failed To Fetch Invoice PDF"
              );
            }
          },
          error: () => {
            this.showSmallLoader = false;
            this._toastr.error("Error", "Failed To Fetch Invoice PDF");
          },
        });
    }
  }

  b64toBlob(b64Data: string, contentType = "", sliceSize = 512) {
    const byteCharacters = atob(b64Data);
    const byteArrays = [];

    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }

      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }

  closeUrlDialog() {
    this.invoicePdfDialogue = false;
  }

  onClear() {
    this.clearAndSetSimpleOrderSearchResponseObj();
    this._sharedService.setOrderSearchValue("");
    this._sharedService.setOrderSearchPlaceholderValue("Search");
    this._router
      .navigateByUrl("orders/refresh-component", {
        skipLocationChange: true,
      })
      .then(() => {
        this._router.navigate(["orders"]);
      });
  }

  clearFilter() {
    this.selectedMatchMode = "";
    this.startDate = "";
    this.endDate = "";
    this.inHandDateFilter = {} as DateFilter;
    this.filterSaleordersListing = this.saleordersListing;
  }

  descriptionCharacterCount(obj: string) {
    if (obj) {
      if (obj.length > 30) this.descriptionCharacterCond = true;
    }
  }

  custPoCharacterCountMethod(obj: string) {
    if (obj) {
      if (obj.length > 15) this.custPoCharacterCount = true;
    }
  }

  // getOrderType(rowIndex: number) {
  //   switch (this.orderType) {
  //     case 'inventory-sales':
  //       return 'Yes';
  //       break;
  //     case 'category-sales':
  //       return 'No';
  //       break;
  //     case 'all-sales':
  //       return rowIndex % 4 == 0 ? 'Yes' : 'No';
  //       // Expected output: "Mangoes and papayas are $2.79 a pound."
  //       break;
  //     default:
  //       return 'No';
  //   }
  // }

  scrollHiddenStatus() {
    setTimeout(() => {
      this.renderer.removeClass(document.body, "p-overflow-hidden");
    }, 0);
  }

  redirectToIRSummary(saleOrderId: string, projId: string) {
    if (saleOrderId && projId) {
      const url = `invoice-review/invoice-review-summary/${saleOrderId}/${projId}`;
      window.open(url);
    }
  }

  getProjectInvoiceProposalsBySalesOrderId(salesOrderId: string) {
    this.popupSmallLoader = true;
    this.displayProjectInvoiceProposal = true;
    this._orderListingPaginatedService
      .getProjectInvoiceProposalsBySalesOrderId(salesOrderId)
      .pipe(untilDestroyed(this))
      .subscribe({
        next: res => {
          this.popupSmallLoader = false;
          if (res.data && res.status.toLowerCase() === "success") {
            if (res.data?.Proposals) {
              this.projectInvoicesProposalList = res.data.Proposals;
            }
          } else {
            this._toastr.error("Error", res.message);
          }
        },
        error: () => {
          this._toastr.error("Error", "Unable to fetch invoices from D365");
          this.popupSmallLoader = false;
        },
      });
  }

  closeProjectInvoiceProposalEvent() {
    this.displayProjectInvoiceProposal = false;
    this.projectInvoicesProposalList = [] as GetProjectInvoiceProposalsList[];
  }

  getUserProfile() {
    this._loginService
      .validateLogin()
      .pipe()
      .subscribe(res => {
        this.userRole = res.data.userRoleId;
      });
  }

  closeModal() {
    this.openOrderListingModal.emit();
  }
}
